import React from "react";

// Components
import GameCard from "../components/GameCard";
import MainView from "../components/MainView";

export default function Home() {
  const games = [
    {
      game_id: "kangaroo",
      game_name: "Kangaroo",
      game_file: "Kangaroo",
      game_desc:
        "Squat up and down to collect all the stars. The more stars you collect the higher your score!",
      game_level: 5,
      coming_soon: false,
    },
    {
      game_id: "flappybird",
      game_name: "Flappy Bird",
      game_file: "FlappyBird",
      game_desc:
        "Squat up and down to collect all the stars. The more stars you collect the higher your score!",
      game_level: 5,
      coming_soon: false,
    },
    {
      game_id: "duracellbunny",
      game_name: "Duracell Bunny",
      game_file: "DuracellBunny",
      game_desc:
        "Squat up and down to collect all the stars. The more stars you collect the higher your score!",
      game_level: 5,
      coming_soon: true,
    },
    {
      game_id: "reachgame",
      game_name: "Reach Game",
      game_file: "ReachGame",
      game_desc:
        "Squat up and down to collect all the stars. The more stars you collect the higher your score!",
      game_level: 5,
      coming_soon: true,
    },
  ];

  return (
    <MainView>
      <div className="pt-10 pb-20 px-[5vw] 2xl:px-[15vw]">
        <div
          id="gameCardBox"
          className="mx-auto max-w-[300px] sm:max-w-full xl:max-w-6xl"
        >
          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 sm:gap-8">
            {games.map((game) => (
              <div className="mt-5 first:mt-0 sm:mt-0" key={game.game_id}>
                <GameCard game={game} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </MainView>
  );
}
